import React, { useEffect } from 'react'
import Navbar from './Navbar'
import Select from 'react-select'
import "../css/petData.css"
import "../css/petParentData.css"
import axios from 'axios'
import { useState } from 'react'
import { v4 as uuidv4 } from 'uuid';
import { Cloudinary } from 'cloudinary-core';
import Footer from './Footer'
import { useNavigate } from 'react-router-dom'
import ReCAPTCHA from "react-google-recaptcha";
import RingLoader from "react-spinners/RingLoader"
import "../css/loading.css"



function PetData() {

    const [visible, setVisible] = useState(false);
    const [busy, setBusy] = useState(false);
    const [message, setMessage] = useState('');
    const [captcha, setCaptcha] = useState('');



    const onChange = () => {
        setCaptcha(true)
    }

    const handleNextButton = () => {
        if (
            !pets.petname ||
            !Category ||
            !Sex ||
            !Age ||
            !pets.breed ||
            !Vaccinated ||
            !pets.address ||
            !pets.petnote ||
            !petSelected
        ) {
            window.alert("Please fill the fields")
            return;
        }
        setVisible(true);
    };


    const selectBoxStyling = {

        option: (defaultStyles, state) => ({
            ...defaultStyles,
            fontFamily: "'Poppins', sans-serif",
            color: state.isSelected ? "white" : "black",
            backgroundColor: state.isSelected ? "#FFDAC1" : "white",
            fontSize: "0.9rem",
            fontWeight: "500",
            padding: "5px 12px",

            // Phone view styling

            '@media (max-width: 600px)': {
                fontSize: "0.6rem",
                fontWeight: "500",
                padding: "5px 12px",

            }

        }),


        control: (defaultStyles) => ({
            ...defaultStyles,
            fontFamily: "'Poppins', sans-serif",
            borderRadius: "10px",
            padding: "0px",
            border: "none",
            outline: "none",
            backgroundColor: "rgba(255, 255, 255, 0.5)",
            boxShadow: "inset -3px -3px rgba(255, 255, 255, 0.5)",
        }),

        singleValue: (defaultStyles) => ({
            ...defaultStyles, color: "black"
        }),

    }


    const [Category, setCategory] = useState("")
    const category = [
        { value: 'Cat', label: 'Cat' },
        { value: 'Dog', label: 'Dog' },
        { value: 'Bird', label: 'Bird' },
        { value: 'Fish', label: 'Fish' },
        { value: 'Turtle', label: 'Turtle' },
        { value: 'Rabbit', label: 'Rabbit' },
        { value: 'Other', label: 'Other' },

    ]

    const [Sex, setSex] = useState("")
    const sex = [
        { value: 'Female', label: 'Female' },
        { value: 'Male', label: 'Male' }
    ]


    const [Age, setAge] = useState("")
    const age = [
        { value: 'Baby', label: 'Baby' },
        { value: 'Adolescent', label: 'Adolescent' },
        { value: 'Adult', label: 'Adult' },
        { value: 'Senior', label: 'Senior' }
    ]

    const [Vaccinated, setVaccinated] = useState("")
    const vaccinated = [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
    ]

    const [Trained, setTrained] = useState("")
    const trained = [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
    ]

    const [Neutered, setNeutered] = useState("")
    const neutered = [
        { value: 'Yes', label: 'Yes' },
        { value: 'No', label: 'No' }
    ]


    const [pets, setPets] = useState({
        petname: '',
        ownername: '',
        breed: '',
        address: '',
        petnote: '',
        email: '',
        whatsapp: '',
        contact: '',
        facebook: '',
        ownernote: ''
    })

    const [petSelected, setPetSelected] = useState('');
    const [ownerSelected, setOwnerSelected] = useState('');
    const [petImageUrl, setPetImageUrl] = useState('');
    const [ownerImageUrl, setOwnerImageUrl] = useState('');
    const [value, setValue] = useState('register');
    const [error, setError] = useState(null);




    const petImageUpload = (event) => {
        setPetSelected(event.target.files[0]);

    };
    const ownerImageUpload = (event) => {
        setOwnerSelected(event.target.files[0]);
    };


    const handleButton = async (value) => {
        try {
            setBusy(true)
            await axios.post(`https://petme.onrender.com/user/mailSender?email=${pets.email}`, { value });

            setBusy(false)
            console.log('Email sent successfully');
        } catch (error) {
            console.error('Error sending email:', error);
        }
    }

    const petHandleUpload = async () => {
        try {
            if (!petSelected) {
                setError('No file selected');
                return;
            }

            const formData = new FormData();
            formData.append('image', petSelected);

            const response = await axios.post('https://petme.onrender.com/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            setPetImageUrl(response.data.imageUrl);

        } catch (error) {
            console.error('Error uploading image:', error);
            setError('Image upload failed');
        }
    };

    const ownerhandleUpload = async () => {
        try {
            if (!ownerSelected) {
                setError('No file selected');
                return;
            }

            const formData = new FormData();
            formData.append('image', ownerSelected);

            const response = await axios.post('https://petme.onrender.com/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });

            setOwnerImageUrl(response.data.imageUrl);
        } catch (error) {
            console.error('Error uploading image:', error);
            setError('Image upload failed');
        }
    };





    const handleChange = (e) => {

        const { name, value } = e.target
        setPets({ ...pets, [name]: value })
    }


    const navigate = useNavigate();


    useEffect(() => {
        if (petImageUrl && ownerImageUrl) {
            petregister();
        }
    }, [petImageUrl, ownerImageUrl])

    const submit = async () => {
        if (!pets.ownername || !pets.contact || !pets.email) {
            window.alert("Please fill the fields")
        }
        setBusy(true)
        await petHandleUpload();
        await ownerhandleUpload();
    }
    const petregister = async () => {
        // e.preventDefault()

        const { petname, ownername, breed, address, petnote, whatsapp, contact, facebook, email, ownernote } = pets;
        
        const res = await fetch("https://petme.onrender.com/petregister", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify({
                ownerImageUrl, petImageUrl, petname, Category, ownername, Sex, Age, breed, Trained, Neutered, Vaccinated, address, petnote, email, whatsapp, contact, facebook, ownernote
            })
        });


        const data = await res.json();
        handleButton(value);

        if (data.status === 422 || !data) {
            window.alert(data.error);


        } if (data.status === 409 || !data) {
            console.log(data.message)
            window.alert(data.message);
        }


        else {
            setMessage(data.message);
            setBusy(false)
            setTimeout(() => {
                navigate("/home")
            }, 3000);
        }

    }

    if(busy){
        return(
          <div className="loader-container" >
        <RingLoader color="#36d7b7" loading size={90} />
        <h1 className="loading-heading">Loading....</h1>
      </div>
        )
      }
    if (message) {
        return (
            <div className="petData-msgDiv">
                <h2 className="petData-msgHeading">{message}</h2>
            </div>
        )
    }


    return (
        <div>
            <Navbar />
            {!visible && (<div className="pet-data-container">

                <div className="pet-data-div">
                    <h1 className="pet-data-heading">Pet Data</h1>
                    <form action="" className="pet-data-form">

                        <div className="pair">
                            <div className="data-feed">
                                <p className="pet-data-details">Pet Name</p>
                                <input id="pet-data" type="form" name="petname" value={pets.petname} onChange={handleChange} className="pet-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="pet-data-details">Pet Category</p>
                                <Select
                                    className="petData-selector"
                                    options={category}
                                    placeholder="select category"
                                    value={category.find((option) => option.value === Category)}
                                    onChange={(selectedOption) => {
                                        setCategory(selectedOption.value);
                                    }}
                                    isSearchable
                                    noOptionsMessage={() => "not found"}
                                    styles={selectBoxStyling}
                                />
                            </div>
                        </div>

                        <div className="pair">
                            <div className="data-feed">
                                <p className="pet-data-details">Sex</p>
                                <div >
                                    <Select
                                        className="petData-selector"
                                        options={sex}
                                        placeholder="Select sex"
                                        value={sex.find((option) => option.value === Sex)}
                                        onChange={(selectedOption) => {
                                            setSex(selectedOption.value);
                                        }}
                                        isSearchable
                                        noOptionsMessage={() => "Not found"}
                                        styles={selectBoxStyling}
                                    />
                                </div>
                            </div>

                            <div className="data-feed">
                                <p className="pet-data-details">Image</p>
                                <input id="pet-data" type="file" name="image" onChange={petImageUpload} className="pet-details-box" placeholder="" />
                            </div>
                        </div>

                        <div className="pair">
                            <div className="data-feed">
                                <p className="pet-data-details">Age</p>
                                <Select
                                    className="petData-selector"
                                    options={age}
                                    placeholder="Select age"
                                    value={age.find((option) => option.value === Age)}
                                    onChange={(selectedOption) => {
                                        setAge(selectedOption.value);
                                    }}
                                    isSearchable
                                    noOptionsMessage={() => "not found"}
                                    styles={selectBoxStyling}
                                />
                            </div>

                            <div className="data-feed">
                                <p className="pet-data-details">Breed</p>
                                <input id="pet-data" type="form" name="breed" value={pets.breed} onChange={handleChange} className="pet-details-box" placeholder="" />
                            </div>
                        </div>


                        <div className="pair">
                            <div className="data-feed">
                                <p className="pet-data-details">Vaccinated</p>
                                <Select
                                    className="petData-selector"
                                    options={vaccinated}
                                    placeholder="select yes or no"
                                    value={vaccinated.find((option) => option.value === Vaccinated)}
                                    onChange={(selectedOption) => {
                                        setVaccinated(selectedOption.value);
                                    }}
                                    isSearchable
                                    noOptionsMessage={() => "not found"}
                                    styles={selectBoxStyling}
                                />
                            </div>

                            <div className="data-feed">
                                <p className="pet-data-details">Location</p>
                                <input id="pet-data" type="form" name="address" value={pets.address} onChange={handleChange} className="pet-details-box" placeholder="" />
                            </div>
                        </div>


                        <div className="pair">
                            <div className="data-feed">
                                <p className="pet-data-details">Trained</p>
                                <Select
                                    className="petData-selector"
                                    options={trained}
                                    placeholder="select yes or no"
                                    value={trained.find((option) => option.value === Trained)}
                                    onChange={(selectedOption) => {
                                        setTrained(selectedOption.value);
                                    }}
                                    isSearchable
                                    noOptionsMessage={() => "not found"}
                                    styles={selectBoxStyling}
                                />
                            </div>

                            <div className="data-feed">
                                <p className="pet-data-details">Neutered</p>
                                <Select
                                    className="petData-selector"
                                    options={neutered}
                                    placeholder="select yes or no"
                                    value={neutered.find((option) => option.value === Neutered)}
                                    onChange={(selectedOption) => {
                                        setNeutered(selectedOption.value);
                                    }}
                                    isSearchable
                                    noOptionsMessage={() => "not found"}
                                    styles={selectBoxStyling}
                                />
                            </div>
                        </div>

                        <div className="pet-note">
                            <p className="pet-data-details ">Any note about pet</p>
                            <textarea id="pet-data" className="pet-details-box  pet-note-box" name="petnote" value={pets.petnote} onChange={handleChange} rows={4} cols={40} />
                        </div>

                    </form>

                    <button className="petDetails-submitBtn" onClick={handleNextButton}>Next</button>


                </div>
            </div>)}



            {visible && (<div className="parent-data-container">

                <div className="petParent-data-div">
                    <h1 className="parent-data-heading">Parent Data</h1>
                    <form action="" className="parent-data-form">

                        <div className="pair">
                            <div className="data-feed">
                                <p className="parent-data-details">Parent Name</p>
                                <input id="parent-data" type="form" name="ownername" value={pets.ownername} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="parent-data-details">Parent Image</p>
                                <input id="parent-data" type="file" name="form" className="parent-details-box" onChange={ownerImageUpload} placeholder="" />
                            </div>
                        </div>

                        <div className="pair">
                            <div className="data-feed">
                                <p className="parent-data-details">Contact</p>
                                <input id="parent-data" type="form" name="contact" value={pets.contact} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="parent-data-details">WhatsApp</p>
                                <input id="parent-data" type="form" name="whatsapp" value={pets.whatsapp} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>
                        </div>

                        <div className="pair">
                            <div className="data-feed">
                                <p className="parent-data-details">Email</p>
                                <input id="parent-data" type="form" name="email" value={pets.email} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>

                            <div className="data-feed">
                                <p className="parent-data-details">Facebook</p>
                                <input id="parent-data" type="form" name="facebook" value={pets.facebook} onChange={handleChange} className="parent-details-box" placeholder="" />
                            </div>
                        </div>

                        <div className="parent-note">
                            <p className="parent-data-details ">Any note about owner</p>
                            <input id="parent-data" type="form" name="ownernote" value={pets.ownernote} onChange={handleChange} className="parent-details-box  parent-note-box" placeholder="" />
                        </div>

                    </form>
                    <ReCAPTCHA sitekey="6LfMrgonAAAAAKLie8JOmZT_LIcXwh4gKFhQj4v8" onChange={onChange} />
                    {captcha && (<button className="parentDetails-submitBtn" onClick={submit}>Submit</button>)}
                </div>
            </div>)}
            <Footer />

        </div>
    )
}

export default PetData